import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Params, Router } from '@angular/router';
import { BaseComponentDirective, UrlUtils } from '@streamamg/amg-common';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'amg-link',
  templateUrl: './link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkComponent extends BaseComponentDirective implements OnInit {

  @Input() fullPathSelectedItem = false;
  @Input() text: string;
  @Input() path: string;
  @Input() cssClass: string;
  @Input() targetLink: '_self' | '_blank' | '_parent' | '_top';

  @HostBinding('class.selected') isActive: boolean = false;

  public isInternal: boolean;
  public link: string;
  public queryParams: Params;
  public fragment: string;
  public url: URL;

  constructor(
    private cd: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {
    super();
  }

  ngOnInit(): void {

    if (this.path && !UrlUtils.isExternal(this.path)) {

      this.isInternal = true;
      this.setInternalLink();

    } else {

      // for external link set to open in a new tab as default
      this.targetLink = this.targetLink || '_blank';
    }

    this.cd.detectChanges();
  }

  public setInternalLink(): void {
    this.link = '';
    if (this.path && this.path !== '' && this.path !== '/') {
      this.url = new URL(`${!this.path.startsWith('http') ? window.location.origin: ''}${!this.path.startsWith('/') ? '/': ''}${this.path}`);

      this.fragment = this.url.hash !== '' || this.url.href.includes('/#') ? this.url.hash.replace('#', ''): null;
      this.queryParams = {};
      this.url.searchParams.forEach((value, key) => {

        this.queryParams[key] = value;
      });

      this.setIsActive();

      this.link = this.url.pathname;
      this.cd.detectChanges();

      super.subSink = this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe(() => {

          this.setIsActive();
          this.cd.markForCheck();
        });
    }
  }

  public onClick(): void {

    const onClickEvent = new CustomEvent('linkClicked', {
      bubbles: true,
      detail: {link: () => this.url.href},
    });

    window.dispatchEvent(onClickEvent);
  }

  private setIsActive(): void {
    if(this.fullPathSelectedItem) {
      this.isActive = (window.location.href === this.url.href) ||
        (window.location.href === this.url.href.slice(0, this.url.href.lastIndexOf('/')));
    } else {
      this.isActive = (window.location.pathname === this.url.pathname) ||
        (window.location.pathname === this.url.pathname.slice(0, this.url.pathname.lastIndexOf('/')));
    }
  }
}
